/* ============
 * Bill Module State
 * ============
 */

export default {
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentBill: {},
  statuses: [],
  types: [],
  query: {
    page: 1,
    limit: 50,
    search: '',
    isSet: false,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/bill/state.js